"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const crypto_1 = require("@iov/crypto");
const encoding_1 = require("@iov/encoding");
const { toUtf8 } = encoding_1.Encoding;
class KeyringEncryptor {
    static encrypt(keyringSerialization, encryptionKey) {
        return __awaiter(this, void 0, void 0, function* () {
            if (encryptionKey.length !== 32) {
                throw new Error("32 byte encryption key expected");
            }
            // Format version 1 specs:
            // - encode keyring serialization as UTF-8
            // - use Xchacha20poly1305Ietf with 24 byte nonce
            // - prepend nonce to ciphertext
            const formatVersion = new encoding_1.Uint32(1);
            const keyringPlaintext = toUtf8(keyringSerialization);
            const keyringNonce = yield KeyringEncryptor.makeXchacha20poly1305IetfNonce();
            const keyringCiphertext = yield crypto_1.Xchacha20poly1305Ietf.encrypt(keyringPlaintext, encryptionKey, keyringNonce);
            const out = new Uint8Array([...formatVersion.toBytesBigEndian(), ...keyringNonce, ...keyringCiphertext]);
            return out;
        });
    }
    static decrypt(encrypted, encryptionKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const formatVersionLength = 4;
            const formatVersion = encoding_1.Uint32.fromBigEndianBytes(encrypted.slice(0, formatVersionLength));
            switch (formatVersion.toNumber()) {
                case 1: {
                    const nonceLength = 24;
                    const nonce = encrypted.slice(formatVersionLength, formatVersionLength + nonceLength);
                    const ciphertext = encrypted.slice(formatVersionLength + nonceLength);
                    const decrypted = yield crypto_1.Xchacha20poly1305Ietf.decrypt(ciphertext, encryptionKey, nonce);
                    return encoding_1.Encoding.fromUtf8(decrypted);
                }
                default:
                    throw new Error(`Unsupported format version: ${formatVersion.toNumber()}`);
            }
        });
    }
    static makeXchacha20poly1305IetfNonce() {
        return __awaiter(this, void 0, void 0, function* () {
            return crypto_1.Random.getBytes(24);
        });
    }
}
exports.KeyringEncryptor = KeyringEncryptor;
//# sourceMappingURL=keyringencryptor.js.map